// extracted by mini-css-extract-plugin
export default {"wrapper":"Y3mhf","infos":"NBqj9","content":"qqynV","textContainer":"DdLdZ","title":"fQYAi","text":"bsWfj"};